/**
 * Librerias
 */
import React,{useEffect, useState} from "react";
import Swal from "sweetalert2"
import { HiSearch } from "react-icons/hi";

/**
 * Styles
 */
import '../../styles/table.css'

import { updateMedicalCredential, deleteMedicalCredential } from '../../objects/asociado';

const CredentialTable = ({medicos,setAsociado,setDocumentoSeleccionado,setIsMostrarUsuarios,uhList,setIsMostrarCredencial,
    isMostrarPacientes,nomHospitalUser,userLevel,uhSelected,isReadOnly}) =>{

    const [constanciaUnoName,setConstanciaUnoName] = useState("")

    const [constanciaDosName,setConstanciaDosName] = useState("")

    const [constanciaTresName,setConstanciaTresName] = useState("")

    const [constanciaCuatroName,setConstanciaCuatroName] = useState("")

    const [constanciaCincoName,setConstanciaCincoName] = useState("")

    const [medicosAMostrar, setMedicosAMostrar] = useState([])
    const [isAdmin, setIsAdmin] = useState(true)


    useEffect(()=>{
        let five = new Date().getFullYear();
        let four = five -1;
        let three = four -1;
        let two = three - 1
        let one = two - 1
        setConstanciaUnoName(one)
        setConstanciaDosName(two)
        setConstanciaTresName(three)
        setConstanciaCuatroName(four)
        setConstanciaCincoName(five)

    },[])

    useEffect(()=>{
        if(userLevel){
            if(userLevel === "superuser"){
                setIsAdmin(true)
            }
            else{
                setIsAdmin(false)
            }
        }
        else{
            setIsAdmin(false)
        }
    },[userLevel])

    useEffect(()=>{
        if(medicos){
            let medicosArray = []
            for(let i=0;i<medicos.length;i++){
                if(nomHospitalUser === medicos[i].hospital || userLevel === 'superuser'){
                    if(uhSelected === "General"){
                        if(isMostrarPacientes){
                            if(medicos[i].active){
                                medicos[i].isEditable = true
                                medicosArray.push(medicos[i])
                            }
                        }
                        else{
                            if(!medicos[i].active){
                                medicos[i].isEditable = true
                                medicosArray.push(medicos[i])
                            }
                        }
                    }
                    else{
                        if(uhSelected === medicos[i].hospital){
                            if(isMostrarPacientes){
                                if(medicos[i].active){
                                    medicos[i].isEditable = true
                                    medicosArray.push(medicos[i])
                                }
                            }
                            else{
                                if(!medicos[i].active){
                                    medicos[i].isEditable = true
                                    medicosArray.push(medicos[i])
                                }
                            }
                        }
                    }
                }
                else{
                    if(nomHospitalUser === "MAC Aguascalientes Sur" || nomHospitalUser === "MAC Aguascalientes Norte"){
                        if(medicos[i].hospital === "MAC Aguascalientes Sur" || medicos[i].hospital === "MAC Aguascalientes Norte"){
                            medicos[i].isEditable = false
                            medicosArray.push(medicos[i])
                        }
                    }
                }
                
            }
            setMedicosAMostrar(medicosArray)
        }
        else{
            setMedicosAMostrar([])
        }
    },[medicos,isMostrarPacientes,nomHospitalUser,userLevel,uhSelected])

    const getEspecialidades = (evento) => (event) => {
        event.preventDefault()
        const resultado = medicos.find( uh => uh.id === evento.id )
        if(resultado){
            let contactos = ""
            contactos += "<h2 class=modalPacienteTitle>Especialidad:</h2>"
            if(resultado.gender === '1'){
                contactos += "<h1 class='info_itemblog'>"+resultado.name+" "+resultado.lastname+"</h1>"
            }
            else{
                contactos += "<h1 class='info_itemblog'>"+resultado.name+" "+resultado.lastname+"</h1>"
            }
            for(let i=0; i< resultado.specialty_array.length;i++){
                contactos += "<h1 class='info_item_fecha'>"+resultado.specialty_array[i]+"</h1>"
            }
            Swal.fire({
                html:
                contactos,
                showCloseButton: true,
                showConfirmButton:false,
                customClass: 'swal-height'
            })
        }
    }

    const handleActualizarEntregaDocumento = (paciente,opcion,estatus) => (event) => {
        event.preventDefault()
        if(paciente.isEditable && !isReadOnly){
            let mensaje = ""

            let nombreMedico = ""
            if(paciente.gender === '1'){
                nombreMedico = paciente.name+" "+paciente.lastname
            }
            else{
                nombreMedico = paciente.name+" "+paciente.lastname
            }
            switch(opcion){
                case 1:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia título profesional de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia título profesional de " +nombreMedico + "?"
                    }
                    break
                case 2:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia cédula profesional de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia cédula profesional de " +nombreMedico + "?"
                    }
                    break
                case 3:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia cédula especialidad de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia cédula especialidad de " +nombreMedico + "?"
                    }
                    break
                case 4:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia título especialidad de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia título especialidad de " +nombreMedico + "?"
                    }
                    break
                case 5:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia título especialidad de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia título especialidad de " +nombreMedico + "?"
                    }
                    break
                case 6:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega del Currículum Vitae de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega del Currículum Vitae de " +nombreMedico + "?"
                    }
                    break
                case 7:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Fotografía de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Fotografía de " +nombreMedico + "?"
                    }
                    break
                case 8:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia del INE de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia del INE de " +nombreMedico + "?"
                    }
                    break
                case 9:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia del RFC de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia del RFC de " +nombreMedico + "?"
                    }
                    break
                case 10:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia del Aviso de funcionamiento de consultorio de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia del Aviso de funcionamiento de consultorio de " +nombreMedico + "?"
                    }
                    break
                case 11:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia del Registro estatal de profesiones de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia del Registro estatal de profesiones de " +nombreMedico + "?"
                    }
                    break
                case 12:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia de la Cédula profesional de sub especialidad de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia de la Cédula profesional de sub especialidad de " +nombreMedico + "?"
                    }
                    break
                case 13:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia de la Certificación de consejo de especialidad de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia de la Certificación de consejo de especialidad de " +nombreMedico + "?"
                    }
                    break
                case 14:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaUnoName + " de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaUnoName + " de " +nombreMedico + "?"
                    }
                    break
                case 15:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaDosName + " de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaDosName + " de " +nombreMedico + "?"
                    }
                    break
                case 16:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaTresName + " de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaTresName + " de " +nombreMedico + "?"
                    }
                    break
                case 17:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaCuatroName + " de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaCuatroName + " de " +nombreMedico + "?"
                    }
                    break
                case 18:
                    if(estatus){
                        mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaCincoName + " de " +nombreMedico + "?"
                    }
                    else{
                        mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaCincoName + " de " +nombreMedico + "?"
                    }
                    break
                default:
                    mensaje = ""
            }
            Swal.fire({
                title: mensaje,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonColor: '#04afaa',
                confirmButtonText: 'Aceptar',
                denyButtonText: `Cancelar`,
                cancelButtonText:`Cancelar`,
            }).then((result) => {
                if (result.isConfirmed) {
                switch(opcion){
                        case 1:
                            paciente.copy_professional_title = estatus
                            break
                        case 2:
                            paciente.copy_professional_license = estatus
                            break
                        case 3:
                            paciente.copy_specialty_certificate = estatus
                            break
                        case 4:
                            paciente.copy_specialty_title = estatus
                            break
                        case 5:
                            paciente.copy_subspecial_title = estatus
                            break
                        case 6:
                            paciente.curriculum_vitae = estatus
                            break
                        case 7:
                            paciente.photo = estatus
                            break
                        case 8:
                            paciente.ine = estatus
                            break
                        case 9:
                            paciente.rfc = estatus
                            break
                        case 10:
                            paciente.copy_of_office_operating_notice = estatus
                            break
                        case 11:
                            paciente.copy_state_registry_of_professions = estatus
                            break
                        case 12:
                            paciente.copy_subspecialty_professional_certificate = estatus
                            break
                        case 13:
                            paciente.copy_specialty_board_certification = estatus
                            break
                        case 14:
                            paciente.contancies[0].sendig = estatus
                            break
                        case 15:
                            paciente.contancies[1].sendig = estatus
                            break
                        case 16:
                            paciente.contancies[2].sendig = estatus
                            break
                        case 17:
                            paciente.contancies[3].sendig = estatus
                            break
                        case 18:
                            paciente.contancies[4].sendig = estatus
                            break
                        default:
                            mensaje = ""
                    }

                    let hoy = new Date()
                    if(!paciente.create){
                        paciente.create = hoy.getFullYear()+"-"+(hoy.getMonth()+1)+"-"+hoy.getDate()
                    }

                    actualizarCredential()
                    async function actualizarCredential(){
                        const response = await updateMedicalCredential(paciente.id,paciente)

                        if(response === "success"){//Actualización de usuario exitosa
                            Swal.fire({
                                icon: 'success',
                                title: 'Credencial actualizada',
                                text: 'Credencial actualizada de manera correcta',
                                confirmButtonText: "Aceptar",
                                confirmButtonColor: "#04afaa",
                            })
                        }
                        else{//Error en la actualización de usuario
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: response,
                            })
                        }
                    }
                }
            })
        }
    }

    const handleOpenImageView = (paciente,opcion,estatus) => (event) => {
        event.preventDefault()
        setAsociado(paciente)
        setDocumentoSeleccionado(opcion)
        setIsMostrarUsuarios(true)
    }

    const handleActualizarCredencial = (paciente) => (event) => {
        event.preventDefault()
        
        let activeOpciones = ""
        if(paciente.active){
            activeOpciones += "<option value=1 selected>Vigente</option>"
            activeOpciones += "<option value=2>Inactivo</option>"
        }
        else{
            activeOpciones += "<option value=1>Vigente</option>"
            activeOpciones += "<option value=2 selected>Inactivo</option>"
        }

        let uhOpciones = ""
        uhList.forEach(uh => {
            if(uh.hospital === paciente.hospital){
                uhOpciones+="<option value="+uh.hospital+" selected>"+uh.hospital+"</option>"
            }
            else{
                uhOpciones+="<option value="+uh.hospital+">"+uh.hospital+"</option>"
            }
        })

        let especialidadUno = ""
        if(paciente.specialty_array[0]){
            especialidadUno = paciente.specialty_array[0]
        }
        let especialidadDos = ""
        if(paciente.specialty_array[1]){
            especialidadDos = paciente.specialty_array[1]
        }
        let especialidadTres = ""
        if(paciente.specialty_array[2]){
            especialidadTres = paciente.specialty_array[2]
        }

        let cedulaUno = ""
        if(paciente.cedula_array[0]){
            cedulaUno = paciente.cedula_array[0]
        }
        let cedulaDos = ""
        if(paciente.cedula_array[1]){
            cedulaDos = paciente.cedula_array[1]
        }
        let cedulaTres = ""
        if(paciente.cedula_array[2]){
            cedulaTres = paciente.cedula_array[2]
        }
        Swal.fire({
            customClass:'modalRegistro',
            html:`<div class="form_wrapper">
                <div class="form_container">
                    <div class="row clearfix">
                        <div class="">
                            <form autocomplete="off" method="post">
                                <h2 class="modalTitle">Editar Asociado `+paciente.identificador+`</h2>
                                <br />
                                <div class="input_field">
                                    <p>Nombre del asociado</p>
                                    <input type="text" name="inputNombre" id="inputNombre" placeholder="Ingrese el nombre del asociado" 
                                    required  class="inputText" autocomplete="off"
                                    oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+paciente.name+`"/>
                                </div>
                                <div class="input_field">
                                    <p>Apellidos del asociado</p>
                                    <input type="text" name="inputApellido" id="inputApellido" placeholder="Ingrese el apellido del asociado" 
                                    required  class="inputText" autocomplete="off"
                                    oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+paciente.lastname+`"/>
                                </div>
                                <div class="input_field">
                                    <p>CURP del asociado</p>
                                    <input type="text" name="inputCurp" id="inputCurp" placeholder="Ingrese el CURP del asociado" 
                                    required  class="inputText" autocomplete="off"
                                    value="`+paciente.curp+`"/>
                                </div>
                                <div class="input_field">
                                    <p>Nombre de especialidad</p>
                                    <input type="text" name="inputEspecialidad" id="inputEspecialidad" placeholder="Ingrese el nombre de especialidad" 
                                    required class="inputText" autocomplete="off"
                                    oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+especialidadUno+`"/>
                                </div>
                                <div class="input_field">
                                    <p>Cédula de especialidad / Universidad</p>
                                    <input type="text" name="inputCedulaEspecialidad" id="inputCedulaEspecialidad" placeholder="Ingrese la cédula de especialidad y su universidad" 
                                    required class="inputText" autocomplete="off"
                                    value="`+cedulaUno+`"/>
                                </div>
                                <div class="input_field">
                                    <p>Nombre de la segunda especialidad</p>
                                    <input type="text" name="inputEspecialidad2" id="inputEspecialidad2" placeholder="Ingrese el nombre de la segunda especialidad" 
                                    required class="inputText" autocomplete="off"
                                    oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+especialidadDos+`"/>
                                </div>
                                <div class="input_field">
                                    <p>Cédula de la segunda especialidad / Universidad</p>
                                    <input type="text" name="inputCedulaEspecialidad2" id="inputCedulaEspecialidad2" placeholder="Ingrese la cédula de la segunda especialidad y su universidad" 
                                    required class="inputText" autocomplete="off"
                                    value="`+cedulaDos+`"/>
                                </div>
                                <div class="input_field">
                                    <p>Nombre de la tercer especialidad</p>
                                    <input type="text" name="inputEspecialidad3" id="inputEspecialidad3" placeholder="Ingrese el nombre de la tercer especialidad" 
                                    required class="inputText" autocomplete="off"
                                    oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+especialidadTres+`"/>
                                </div>
                                <div class="input_field">
                                    <p>Cédula de la tercer especialidad / Universidad</p>
                                    <input type="text" name="inputCedulaEspecialidad3" id="inputCedulaEspecialidad3" placeholder="Ingrese la cédula de la tercer especialidad y su universidad" 
                                    required class="inputText" autocomplete="off"
                                    value="`+cedulaTres+`"/>
                                </div>
                                <div class="input_field">
                                    <p>Nombre de la subespecialidad</p>
                                    <input type="text" name="inputSubEspecialidad" id="inputSubEspecialidad" placeholder="Ingrese el nombre de subespecialidad" 
                                    required class="inputText" autocomplete="off"
                                    oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+paciente.subspecialty+`"/>
                                </div>
                                
                                <div class="input_field select_option">
                                    <p>Unidad Hospitalaria</p>
                                    <select id="selectUH">
                                        `+uhOpciones+`
                                    </select>
                                    <div class="select_arrow"></div>
                                </div>
                                <div class="input_field select_option">
                                    <select id="selectActive">
                                        `+activeOpciones+`
                                    </select>
                                    <div class="select_arrow"></div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>`,
            showDenyButton: true,
            denyButtonText: "Cancelar",
            denyButtonColor: "grey",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#04afaa",
            scrollbarPadding:false,
            allowOutsideClick:false,
            width:'500px',
            heightAuto: false,
            focusConfirm: false,
            showCloseButton:true,
            preConfirm: () => {
                if (document.getElementById('inputNombre').value) {//Se verifica que el campo nombre sea valido
                    if (document.getElementById('inputEspecialidad').value){
                        if (document.getElementById('inputSubEspecialidad').value){
                            if (document.getElementById('inputCurp').value){
                                let isActive = false
                                if(document.getElementById('selectActive').value === "1"){
                                    isActive = true
                                }

                                var combo = document.getElementById("selectUH");
                                var selected = combo.options[combo.selectedIndex].text;


                                if(!paciente.url_copy_professional_title){
                                    paciente.url_copy_professional_title = ''
                                }
                
                                if(!paciente.url_copy_professional_license){
                                    paciente.url_copy_professional_license = ''
                                }
                
                                if(!paciente.url_copy_specialty_certificate){
                                    paciente.url_copy_specialty_certificate = ''
                                }
                
                                if(!paciente.url_copy_specialty_title){
                                    paciente.url_copy_specialty_title = ''
                                }
                
                                if(!paciente.url_copy_subspecial_title){
                                    paciente.url_copy_subspecial_title = ''
                                }
                
                                if(!paciente.url_curriculum_vitae){
                                    paciente.url_curriculum_vitae = ''
                                }

                                if(!paciente.url_photo){
                                    paciente.url_photo = ''
                                }

                                paciente.specialty_array[0] = document.getElementById('inputEspecialidad').value
                                paciente.specialty_array[1] = document.getElementById('inputEspecialidad2').value
                                paciente.specialty_array[2] = document.getElementById('inputEspecialidad3').value

                                paciente.cedula_array[0] = document.getElementById('inputCedulaEspecialidad').value
                                paciente.cedula_array[1] = document.getElementById('inputCedulaEspecialidad2').value
                                paciente.cedula_array[2] = document.getElementById('inputCedulaEspecialidad3').value

                                if(!paciente.basefotografia){
                                    paciente.basefotografia = ''
                                }

                                if(!paciente.copiaTituloProfesionalDay){
                                    paciente.copiaTituloProfesionalDay = ''
                                }

                                if(!paciente.copiaTituloProfesionalExpiraDay){
                                    paciente.copiaTituloProfesionalExpiraDay = ''
                                }

                                if(!paciente.tituloProfesionalExpedidoPor){
                                    paciente.tituloProfesionalExpedidoPor = ''
                                }

                                if(!paciente.copiaCedulaProfesionalDay){
                                    paciente.copiaCedulaProfesionalDay = ''
                                }

                                if(!paciente.copiaCedulaProfesionalExpiraDay){
                                    paciente.copiaCedulaProfesionalExpiraDay = ''
                                }

                                if(!paciente.CedulaProfesionalExpedidoPor){
                                    paciente.CedulaProfesionalExpedidoPor = ''
                                }

                                if(!paciente.copiaCedulaEspecialidadDay){
                                    paciente.copiaCedulaEspecialidadDay = ''
                                }

                                if(!paciente.copiaCedulaEspecialidadExpiraDay){
                                    paciente.copiaCedulaEspecialidadExpiraDay = ''
                                }

                                if(!paciente.CedulaEspecialidadExpedidoPor){
                                    paciente.CedulaEspecialidadExpedidoPor = ''
                                }

                                if(!paciente.copiaTituloEspecialidadDay){
                                    paciente.copiaTituloEspecialidadDay = ''
                                }

                                if(!paciente.copiaTituloEspecialidadExpiraDay){
                                    paciente.copiaTituloEspecialidadExpiraDay = ''
                                }

                                if(!paciente.copiaTituloEspecialidadExpedidoPor){
                                    paciente.copiaTituloEspecialidadExpedidoPor = ''
                                }

                                if(!paciente.copiaTituloSubEspecialidadDay){
                                    paciente.copiaTituloSubEspecialidadDay = ''
                                }

                                if(!paciente.copiaTituloSubEspecialidadExpiraDay){
                                    paciente.copiaTituloSubEspecialidadExpiraDay = ''
                                }

                                if(!paciente.copiaTituloSubEspecialidadExpedidoPor){
                                    paciente.copiaTituloSubEspecialidadExpedidoPor = ''
                                }

                                if(!paciente.copiaTituloSubespecialidadDay){
                                    paciente.copiaTituloSubespecialidadDay = ''
                                }

                                if(!paciente.copiaTituloSubespecialidadExpiraDay){
                                    paciente.copiaTituloSubespecialidadExpiraDay = ''
                                }

                                if(!paciente.copiaTituloSubespecialidadExpedidoPor){
                                    paciente.copiaTituloSubespecialidadExpedidoPor = ''
                                }

                                if(!paciente.certificacionConsejoEspecialidadDay){
                                    paciente.certificacionConsejoEspecialidadDay = ''
                                }

                                if(!paciente.certificacionConsejoEspecialidadExpiraDay){
                                    paciente.certificacionConsejoEspecialidadExpiraDay = ''
                                }

                                if(!paciente.certificacionConsejoEspecialidadExpedidoPor){
                                    paciente.certificacionConsejoEspecialidadExpedidoPor = ''
                                }

                                if(!paciente.avisoFuncionamientoDay){
                                    paciente.avisoFuncionamientoDay = ''
                                }

                                if(!paciente.avisoFuncionamientoExpiraDay){
                                    paciente.avisoFuncionamientoExpiraDay = ''
                                }

                                if(!paciente.avisoFuncionamientoExpedidoPor){
                                    paciente.avisoFuncionamientoExpedidoPor = ''
                                }

                                if(!paciente.registroEstatalProfesionalesDay){
                                    paciente.registroEstatalProfesionalesDay = ''
                                }

                                if(!paciente.registroEstatalProfesionalesExpiraDay){
                                    paciente.registroEstatalProfesionalesExpiraDay = ''
                                }

                                if(!paciente.registroEstatalProfesionalesExpedidoPor){
                                    paciente.registroEstatalProfesionalesExpedidoPor = ''
                                }

                                let hoy = new Date()
                                if(!paciente.create){
                                    paciente.create = hoy.getFullYear()+"-"+(hoy.getMonth()+1)+"-"+hoy.getDate()
                                }

                                let credentialObject = {
                                    "url_copy_specialty_certificate":paciente.url_copy_specialty_certificate,
                                    "url_copy_professional_license":paciente.url_copy_professional_license,
                                    "name":document.getElementById('inputNombre').value,
                                    "url_copy_subspecial_title":paciente.url_copy_subspecial_title,
                                    "url_curriculum_vitae":paciente.url_curriculum_vitae,
                                    "url_copy_professional_title":paciente.url_copy_professional_title,
                                    "status":"Vigente (expediente completo)",
                                    "subspecialty":document.getElementById('inputSubEspecialidad').value,
                                    "url_copy_specialty_title":paciente.url_copy_specialty_title,
                                    "active":isActive,
                                    "specialty":document.getElementById('inputEspecialidad').value,
                                    "curp":document.getElementById('inputCurp').value,
                                    "hospital" : selected,
                                    "copy_specialty_certificate" : paciente.copy_specialty_certificate,
                                    "copy_professional_license" : paciente.copy_professional_license,
                                    "copy_subspecial_title" : paciente.copy_subspecial_title,
                                    "curriculum_vitae" : paciente.curriculum_vitae,
                                    "copy_professional_title" : paciente.copy_professional_title,
                                    "copy_specialty_title" : paciente.copy_specialty_title,
                                    "photo" : paciente.photo,
                                    "url_photo" : paciente.url_photo,
                                    "ine" : paciente.ine,
                                    "url_ine" : paciente.url_ine,
                                    "rfc" : paciente.rfc,
                                    "url_rfc" : paciente.url_rfc,
                                    "copy_of_office_operating_notice" : paciente.copy_of_office_operating_notice,
                                    "url_copy_of_office_operating_notice" : paciente.url_copy_of_office_operating_notice,
                                    "copy_state_registry_of_professions" : paciente.copy_state_registry_of_professions,
                                    "url_copy_state_registry_of_professions" : paciente.url_copy_state_registry_of_professions,
                                    "copy_subspecialty_professional_certificate" : paciente.copy_subspecialty_professional_certificate,
                                    "url_copy_subspecialty_professional_certificate" : paciente.url_copy_subspecialty_professional_certificate,
                                    "copy_specialty_board_certification" : paciente.copy_specialty_board_certification,
                                    "url_copy_specialty_board_certification" : paciente.url_copy_specialty_board_certification,
                                    "contancies" : paciente.contancies,
                                    "gender" : paciente.gender,
                                    "lastname" :  document.getElementById('inputApellido').value,
                                    "specialty_array" : paciente.specialty_array,
                                    "cedula_array" : paciente.cedula_array,
                                    "basefotografia" : paciente.basefotografia,
                                    "copiaTituloProfesionalDay" : paciente.copiaTituloProfesionalDay,
                                    "copiaTituloProfesionalExpiraDay" : paciente.copiaTituloProfesionalExpiraDay,
                                    "tituloProfesionalExpedidoPor" : paciente.tituloProfesionalExpedidoPor,
                                    "copiaCedulaProfesionalDay" : paciente.copiaCedulaProfesionalDay,
                                    "copiaCedulaProfesionalExpiraDay" : paciente.copiaCedulaProfesionalExpiraDay,
                                    "CedulaProfesionalExpedidoPor" : paciente.CedulaProfesionalExpedidoPor,
                                    "copiaCedulaEspecialidadDay" : paciente.copiaCedulaEspecialidadDay,
                                    "copiaCedulaEspecialidadExpiraDay" : paciente.copiaCedulaEspecialidadExpiraDay,
                                    "CedulaEspecialidadExpedidoPor" : paciente.CedulaEspecialidadExpedidoPor,
                                    "copiaTituloEspecialidadDay" : paciente.copiaTituloEspecialidadDay,
                                    "copiaTituloEspecialidadExpiraDay" : paciente.copiaTituloEspecialidadExpiraDay,
                                    "copiaTituloEspecialidadExpedidoPor" : paciente.copiaTituloEspecialidadExpedidoPor,
                                    "copiaTituloSubEspecialidadDay" : paciente.copiaTituloSubEspecialidadDay,
                                    "copiaTituloSubEspecialidadExpiraDay" : paciente.copiaTituloSubEspecialidadExpiraDay,
                                    "copiaTituloSubEspecialidadExpedidoPor" : paciente.copiaTituloSubEspecialidadExpedidoPor,
                                    "copiaTituloSubespecialidadDay" : paciente.copiaTituloSubespecialidadDay,
                                    "copiaTituloSubespecialidadExpiraDay" : paciente.copiaTituloSubespecialidadExpiraDay,
                                    "copiaTituloSubespecialidadExpedidoPor" : paciente.copiaTituloSubespecialidadExpedidoPor,
                                    "certificacionConsejoEspecialidadDay" : paciente.certificacionConsejoEspecialidadDay,
                                    "certificacionConsejoEspecialidadExpiraDay" : paciente.certificacionConsejoEspecialidadExpiraDay,
                                    "certificacionConsejoEspecialidadExpedidoPor" : paciente.certificacionConsejoEspecialidadExpedidoPor,
                                    "avisoFuncionamientoDay" : paciente.avisoFuncionamientoDay,
                                    "avisoFuncionamientoExpiraDay" : paciente.avisoFuncionamientoExpiraDay,
                                    "avisoFuncionamientoExpedidoPor" : paciente.avisoFuncionamientoExpedidoPor,
                                    "registroEstatalProfesionalesDay" : paciente.registroEstatalProfesionalesDay,
                                    "registroEstatalProfesionalesExpiraDay" : paciente.registroEstatalProfesionalesExpiraDay,
                                    "registroEstatalProfesionalesExpedidoPor" : paciente.registroEstatalProfesionalesExpedidoPor,
                                    "create" : paciente.create
                                }

                                solicitarActualizarCredencial()
                                async function solicitarActualizarCredencial(){
                                    const response = await updateMedicalCredential(paciente.id,credentialObject)

                                    if(response === "success"){//Actualización de usuario exitosa
                                        Swal.fire({
                                            icon: 'success',
                                            title: 'Credencial actualizada',
                                            text: 'Credencial actualizada de manera correcta',
                                            confirmButtonText: "Aceptar",
                                            confirmButtonColor: "#04afaa",
                                        })
                                    }
                                    else{//Error en la actualización de usuario
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Error',
                                            text: response,
                                        })
                                    }
                                }
                            }
                            else{
                                Swal.showValidationMessage('Proporcione el CURP del usuario')   
                            }
                        }
                        else{
                            Swal.showValidationMessage('Proporcione la subespecialidad')   
                        }
                    }
                    else{
                        Swal.showValidationMessage('Proporcione la especialidad')   
                    }
                } else {//Nombre de usuario invalido
                    Swal.showValidationMessage('Proporcione el nombre del usuario')   
                }
              }
        })
    }

    const handleVisualizarCredencial = (paciente) => (event) => {
        event.preventDefault()
        setAsociado(paciente)
        setIsMostrarCredencial(true)
    }

    const handleEliminarCredencial = (paciente) => (event) => {
        event.preventDefault()
        Swal.fire({
            title: "¿Desea eliminar al asociado " + paciente.name + "?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: '#04afaa',
            confirmButtonText: 'Aceptar',
            denyButtonText: `Cancelar`,
            cancelButtonText:`Cancelar`,
          }).then((result) => {
            if (result.isConfirmed) {
                eliminarCredential()
                async function eliminarCredential(){
                    const response = await deleteMedicalCredential(paciente.id)

                    if(response === "success"){//Actualización de usuario exitosa
                        Swal.fire({
                            icon: 'success',
                            title: 'Credencial eliminada',
                            text: 'Credencial eliminada de manera correcta',
                            confirmButtonText: "Aceptar",
                            confirmButtonColor: "#04afaa",
                          })
                    }
                    else{//Error en la actualización de usuario
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response,
                          })
                    }
                }
            }
          })
        
    }

    return(
        <>
            <div className="Table">
                <div className="Heading">
                    <div className="Cell">
                        <p></p>
                    </div>
                    {
                        !isReadOnly
                        ?
                            <div className="Cell">
                                <p></p>
                            </div>
                        :
                            null
                    }
                    <div className="Cell">
                        <p>Identificador</p>
                    </div>
                    <div className="Cell">
                        <p>Nombre</p>
                    </div>
                    <div className="Cell">
                        <p>CURP</p>
                    </div>
                    <div className="Cell">
                        <p>Especialidad</p>
                    </div>
                    <div className="Cell">
                        <p>Subespecialidad</p>
                    </div>
                    <div className="Cell">
                        <p>Unidad</p>
                    </div>
                    <div className="Cell">
                        <p>Fotografía</p>
                    </div>
                    <div className="Cell">
                        <p>INE</p>
                    </div>
                    <div className="Cell">
                        <p>RFC</p>
                    </div>
                    <div className="Cell">
                        <p>Copia título profesional</p>
                    </div>
                    <div className="Cell">
                        <p>Copia cédula profesional</p>
                    </div>
                    <div className="Cell">
                        <p>Copia cédula especialidad</p>
                    </div>
                    <div className="Cell">
                        <p>Copia título especialidad</p>
                    </div>
                    <div className="Cell">
                        <p>Copia cédula profesional de sub especialidad</p>
                    </div>
                    <div className="Cell">
                        <p>Copia título subespecialidad</p>
                    </div>
                    <div className="Cell">
                        <p>Copia de la Certificación de consejo de especialidad</p>
                    </div>
                    <div className="Cell">
                        <p>Copia del Aviso de funcionamiento de consultorio</p>
                    </div>
                    <div className="Cell">
                        <p>Copia del Registro Estatal de Profesiones</p>
                    </div>
                    <div className="Cell">
                        <p>Currículum Vitae</p>
                    </div>
                    <div className="Cell">
                        <p>Constancias de cursos o congresos {constanciaUnoName}</p>
                    </div>
                    <div className="Cell">
                        <p>Constancias de cursos o congresos {constanciaDosName}</p>
                    </div>
                    <div className="Cell">
                        <p>Constancias de cursos o congresos {constanciaTresName}</p>
                    </div>
                    <div className="Cell">
                        <p>Constancias de cursos o congresos {constanciaCuatroName}</p>
                    </div>
                    <div className="Cell">
                        <p>Constancias de cursos o congresos {constanciaCincoName}</p>
                    </div>
                    <div className="Cell">
                        <p>Estatus</p>
                    </div>
                    {
                        !isReadOnly
                            ?
                                <div className="Cell">
                                    <p></p>
                                </div>
                            :
                                null
                    }
                    
                </div>
                {
                    medicosAMostrar.map(medico => 
                        <div className="Row" key={medico.id}>
                            {
                                medico.photo
                                    ?
                                        <div className="Cell">
                                            <h1 className='info_itemblogEditar' onClick={handleVisualizarCredencial(medico)}>{ "Credencial".toUpperCase()}</h1> 
                                        </div>
                                    :
                                        <div className="Cell">
                                            
                                        </div>
                            }
                            {
                                !isReadOnly
                                    ?
                                        <div className="Cell">
                                            {
                                                medico.isEditable
                                                    ?
                                                        <h1 className='info_itemblogEditar' onClick={handleActualizarCredencial(medico)}>{ "Actualizar".toUpperCase()}</h1> 
                                                    :
                                                        null
                                            }
                                        </div>
                                    :
                                        null
                            }
                            <div className="Cell">
                                <p>{medico.identificador.toUpperCase()}</p>
                            </div>
                            {
                                medico.gender
                                    ?
                                        <div className="Cell">
                                            <p>{medico.name.toUpperCase() + " "+medico.lastname.toUpperCase()}</p>
                                        </div>
                                    :
                                        <div className="Cell">
                                            <p>{medico.name.toUpperCase() + " "+medico.lastname.toUpperCase()}</p>
                                        </div>
                            }
                            <div className="Cell">
                                <p>{medico.curp.toUpperCase()}</p>
                            </div>
                            <div className="Cell">
                                <h1 className='info_itemblogRequerimientos' onClick={getEspecialidades(medico)}><HiSearch /> { medico.specialty.toUpperCase()}</h1> 
                            </div>
                            <div className="Cell">
                                <p>{medico.subspecialty}</p>
                            </div>
                            <div className="Cell">
                                <p>{medico.hospital}</p>
                            </div>
                            <div className="Cell">
                                {
                                    medico.photo
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,7,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,7,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,7,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,7,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.ine
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,8,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,8,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,8,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,8,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.rfc
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,9,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,9,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,9,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,9,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.copy_professional_title
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,1,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,1,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,1,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,1,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.copy_professional_license
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,2,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,2,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,2,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,2,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.copy_specialty_certificate
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,3,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,3,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,3,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,3,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.copy_specialty_title
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,4,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,4,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,4,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,4,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.copy_subspecialty_professional_certificate
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,12,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,12,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,12,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,12,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.copy_subspecial_title
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,5,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,5,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,5,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,5,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.copy_specialty_board_certification
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,13,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,13,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,13,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,13,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.copy_of_office_operating_notice
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,10,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,10,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,10,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,10,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.copy_state_registry_of_professions
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,11,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,11,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,11,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,11,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.curriculum_vitae
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,6,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,6,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,6,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,6,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.contancies[0].sendig
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,14,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,14,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,14,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,14,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.contancies[1].sendig
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,15,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,15,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,15,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,15,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.contancies[2].sendig
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,16,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,16,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,16,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,16,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.contancies[3].sendig
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,17,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,17,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,17,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,17,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            <div className="Cell">
                                {
                                    medico.contancies[4].sendig
                                        ?
                                            <>
                                                <h1 className='info_itemblogFile'><HiSearch onClick={handleOpenImageView(medico,18,true)}/> <p onClick={handleActualizarEntregaDocumento(medico,18,false)}>Entregado</p></h1> 
                                            </>
                                        :
                                            <>
                                                <h1 className='info_itemblogFilePending'><HiSearch onClick={handleOpenImageView(medico,18,false)}/> <p onClick={handleActualizarEntregaDocumento(medico,18,true)}>Pendiente</p></h1> 
                                            </>
                                }
                            </div>
                            {
                                medico.active
                                    ?
                                        <div className="Cell">
                                            <p>Vigente</p>
                                        </div>
                                    :
                                        <div className="Cell">
                                            <p>Inactivo</p>
                                        </div>
                            }
                            {
                                !isReadOnly
                                    ?
                                        <div className="Cell">
                                            {
                                                medico.isEditable && isAdmin
                                                    ?   
                                                        <h1 className='info_itemblogEliminar' onClick={handleEliminarCredencial(medico)}>{ "Eliminar".toUpperCase()}</h1> 
                                                    :
                                                        null
                                            }
                                            
                                        </div>
                                    :
                                        null
                            }
                            
                        </div>
                    )
                }
            </div>
        </>
    )

}

export default CredentialTable;